$(function(){
	//サイズボタンの 1/2 をspanで囲う
	//htmlメソッドでは最初の一つしか取得できないので条件を追加(※暫定処置)
	const elem_1 = $('.product-form__input input[type=radio]+label:nth-of-type(1)');
    const elem_2 = $('.product-form__input input[type=radio]+label:nth-of-type(2)');
    const elem_3 = $('.product-form__input input[type=radio]+label:nth-of-type(3)');
    const elem_4 = $('.product-form__input input[type=radio]+label:nth-of-type(4)');
    const elem_5 = $('.product-form__input input[type=radio]+label:nth-of-type(5)');
    const elem_6 = $('.product-form__input input[type=radio]+label:nth-of-type(6)');
    const elem_7 = $('.product-form__input input[type=radio]+label:nth-of-type(7)');
    const elem_8 = $('.product-form__input input[type=radio]+label:nth-of-type(8)');
    const elem_9 = $('.product-form__input input[type=radio]+label:nth-of-type(9)');
    const elem_10 = $('.product-form__input input[type=radio]+label:nth-of-type(10)');
    const elem_11 = $('.product-form__input input[type=radio]+label:nth-of-type(11)');
    const elem_12 = $('.product-form__input input[type=radio]+label:nth-of-type(12)');


    if($(elem_1).length){
        const elemTxt_1 = elem_1.html();// 対象の文字列を取得
        const replaceTxt_1 = elemTxt_1.replace(/1\/2/g,'<span>1/2</span>');
        elem_1.html(replaceTxt_1);// 差し替え

    } else if($(elem_2).length){
	
        const elemTxt_2 = elem_2.html();// 対象の文字列を取得
        const replaceTxt_2 = elemTxt_2.replace(/1\/2/g,'<span>1/2</span>');
        elem_2.html(replaceTxt_2);// 差し替え

    } else if($(elem_3).length){
	
        const elemTxt_3 = elem_3.html();// 対象の文字列を取得
        const replaceTxt_3 = elemTxt_3.replace(/1\/2/g,'<span>1/2</span>');
        elem_3.html(replaceTxt_3);// 差し替え

    } else if($(elem_4).length){
	
        const elemTxt_4 = elem_4.html();// 対象の文字列を取得
        const replaceTxt_4 = elemTxt_4.replace(/1\/2/g,'<span>1/2</span>');
        elem_4.html(replaceTxt_4);// 差し替え
    
    } else if($(elem_5).length){
        
        const elemTxt_5 = elem_5.html();// 対象の文字列を取得
        const replaceTxt_5 = elemTxt_5.replace(/1\/2/g,'<span>1/2</span>');
        elem_5.html(replaceTxt_5);// 差し替え

    } else if($(elem_6).length){
        
        const elemTxt_6 = elem_6.html();// 対象の文字列を取得
        const replaceTxt_6 = elemTxt_6.replace(/1\/2/g,'<span>1/2</span>');
        elem_6.html(replaceTxt_6);// 差し替え

    } else if($(elem_7).length){

        const elemTxt_7 = elem_7.html();// 対象の文字列を取得
        const replaceTxt_7 = elemTxt_7.replace(/1\/2/g,'<span>1/2</span>');
        elem_7.html(replaceTxt_7);// 差し替え

    } else if($(elem_8).length){

        const elemTxt_8 = elem_8.html();// 対象の文字列を取得
        const replaceTxt_8 = elemTxt_8.replace(/1\/2/g,'<span>1/2</span>');
        elem_8.html(replaceTxt_8);// 差し替え

    } else if($(elem_9).length){

        const elemTxt_9 = elem_9.html();// 対象の文字列を取得
        const replaceTxt_9 = elemTxt_9.replace(/1\/2/g,'<span>1/2</span>');
        elem_9.html(replaceTxt_9);// 差し替え

    } else if($(elem_10).length){

        const elemTxt_10 = elem_10.html();// 対象の文字列を取得
        const replaceTxt_10 = elemTxt_10.replace(/1\/2/g,'<span>1/2</span>');
        elem_10.html(replaceTxt_10);// 差し替え

    } else if($(elem_11).length){

        const elemTxt_11 = elem_11.html();// 対象の文字列を取得
        const replaceTxt_11 = elemTxt_11.replace(/1\/2/g,'<span>1/2</span>');
        elem_11.html(replaceTxt_11);// 差し替え

    } else if($(elem_12).length){

        const elemTxt_12 = elem_12.html();// 対象の文字列を取得
        const replaceTxt_12 = elemTxt_12.replace(/1\/2/g,'<span>1/2</span>');
        elem_12.html(replaceTxt_12);// 差し替え

    } else {

    }
  
});